
import AppBrowse from "@/components/browse/Browse.vue";
import { Contact } from "@/models/base";
import { BrowseService } from "@/services/browse-service";
import { ToolbarService } from "@/services/toolbar-service";
import { IBrowseDataSource } from "@/utils/browse/browse-data-source";
import Vue from "vue";
import AppImportCsvModal from "../../components/contacts/ImportCsvModal.vue";
import { ProspectService } from "../../services/prospect-service";
import { UserConfigService } from "../../services/user-config-service";
import { checkHasModule } from "../../router";
import { MODULE } from "../../config/modules";
import { View } from "@/models/view";
import { FetchedTotal } from "@/utils/views/fetched-total";
import { ISelectItem } from "winfakt-vue-components";
import { AuthService } from "@/services/auth-service";
import { BrowseState } from "@/utils/browse/browse-state";
import AppSendMessageDialog from "@/components/mail/SendMessageDialog.vue";
import { DossierConfigService } from "@/services";

export default Vue.extend({
	data() {
		return {
			uploadCSVModal: false,
			selectedItems: [] as Contact[],
			browseState: null as null | BrowseState,
			sendMessageDialogContact: null as null | Contact
		};
	},
	props: {
		browseId: Number,
		controlsDisabled: Boolean,
		searchEnabled: Boolean,
		isSearchOnly: Boolean
	},
	computed: {
		baseRoutePath():string{
			return "/contacts/prospects";
		},
		dataSource(): IBrowseDataSource<Contact> {
			let elem = this;
			return {
				getFullElement: (el:Contact)=>ProspectService.getContact(el.ID),
				getSettings: () => BrowseService.getBrowse(this.browseId),
				getElements: ProspectService.getContacts.bind(ProspectService),
				getTotals(view:View):Promise<FetchedTotal[]>{
					return ProspectService.getTotals(view);
				},
				edit(contact: Contact) {
					elem.$router.push(`${elem.baseRoutePath}/edit/${contact.ID}`);
				},
				async delete(contacts: Contact[]) {
					let result = await ProspectService.delContacts(contacts);
					if (!result) {
						await elem.$wf.dialog(elem.$ct("error-cannot-delete"), elem.$t("common.back"), elem.$t("common.attention"), "warning");
						return false;
					}
					return true;
				},
				addRoute: `${elem.baseRoutePath}/new`,
				browseName: "Prospects",
				modelName: "Contact",
				info(contact:Contact){
					elem.$router.push(ProspectService.getInfoRoute(contact.ID));
				},
				browsePermissions: ()=> UserConfigService.getPermissionSettings().ProspectPermissions,
				extraFieldSettings: {
					getExtraFields: ProspectService.getExtraFields.bind(ProspectService),
					nameSettings: DossierConfigService.getExtraFieldNamesConfigs().ProspectNames,
					batchEdit: ProspectService.batchEditExtraField.bind(ProspectService),
					edit: (ProspectService.updateExtraFields as any).bind(ProspectService)
				}
			};
		},
		canWrite():boolean {
			return UserConfigService.hasCurrentUserPermission((p)=>p.ProspectPermissions.hasWritePermissions());
		},
		buttonBarItems():ISelectItem<string | Function>[]{
			let result = [] as ISelectItem<string | Function>[];
			if (this.canWrite && AuthService.hasModule(MODULE.PROSPECTEN)){
				result.push({
					text: this.$ct("ProspectToCustomer").toString(),
					value: "prospect-to-customer",
					icon: "random"
				});
			}
			if (AuthService.isDevModeEnabled){
				result.push({
					text: "Contacten opnieuw opslaan",
					value: this.resaveContacts,
					icon: "save"
				});
			}
			return result;
		},
	},
	watch: {
		"$route.path": {
			immediate: true,
			handler(){
				if (this.$route.path.split("/").length == 3){
					ToolbarService.title = this.$ct("titles.prospects");
				}
			}
		}
	},
	methods: {
		onSearchItemSelected(contact:Contact) {
			this.$emit("search-item-selected", contact);
		},
		async onProspectToCustomer(contact: Contact){
			if (this.selectedItems.length == 0) {
				this.selectedItems.push(contact);
			}
			await ProspectService.toClient(this.selectedItems);
			this.selectedItems.splice(0, this.selectedItems.length);
			this.$wf.notify(this.$ct("common.success").toString(), "success", 3000, "check");
			let browse = (this.$refs.browse as any);
			if (!browse) return;
			browse.refresh();
		},
		async updateView(){
			if (!this.browseState) return;
			await this.browseState.fetch();
		},
		async resaveContacts(){
			await ProspectService.resaveContacts(this.selectedItems.map(c=>c.ID));
			this.$wf.notify("Contacten opnieuw opslaan is gestart", "info", 3000, "info-circle");
		},
		onColClick(result:string, value:Contact){
			if (result == "send-mail") {
				this.sendMessageDialogContact = value;
			}
		},
		closeSendMessageDialog(){
			this.sendMessageDialogContact = null;
		}
	},
	created(){
		if (!checkHasModule(MODULE.PROSPECTEN, this.$router)){
			throw new Error("MISSING MODULE");
		}
	},
	components: {
		AppBrowse,
		AppImportCsvModal,
		AppSendMessageDialog
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	},
});
